<template>
  <router-link :to='to' @click.native='click'>

      <slot></slot>

  </router-link>
</template>
<script>

// NOTE: ONLY works with id anchors - do not use 'name' for it.

// This component was created cause <router-link> doesn't
// handle anchors when comming from another pages AND it also
// doesn't to the anchor point if the url already reflects that anchors -
// clicking on an anchor link, scrolling down, and then clicking again, doesn't
// bring you back to the anchor point.
export default {
    props: ['to'],
    methods: {
        click () {
            const split = this.to.split('#')
            const path = split[0]
            const anchor = split[1]
            // this.$router.push(path)

            if (anchor) this.$nextTick(() => document.getElementById(anchor).scrollIntoView(true))
        }
    }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// apps/comps/Anchor.vue